var map = {
	"./AdGuardDnsInfo.vue": [
		"f258",
		"chunk-4b4541d9"
	],
	"./AdGuardFilterStatus.vue": [
		"6750",
		"chunk-42b37592"
	],
	"./AdGuardStats.vue": [
		"4aa6",
		"chunk-50f31ec3",
		"chunk-284f6914"
	],
	"./AdGuardTopDomains.vue": [
		"72ed",
		"chunk-11e20f6f"
	],
	"./AnonAddy.vue": [
		"a492",
		"chunk-cd2e4284"
	],
	"./Apod.vue": [
		"64ab",
		"chunk-bd9012c4"
	],
	"./BlacklistCheck.vue": [
		"b5ef",
		"chunk-21680640"
	],
	"./Blank.vue": [
		"c16a",
		"chunk-665a1900"
	],
	"./ChuckNorris.vue": [
		"0a33",
		"chunk-45e01918"
	],
	"./Clock.vue": [
		"5e2a",
		"chunk-736b2ef0"
	],
	"./CodeStats.vue": [
		"d7a5",
		"chunk-50f31ec3",
		"chunk-f5300e96"
	],
	"./CovidStats.vue": [
		"714f",
		"chunk-50f31ec3",
		"chunk-3dc88880"
	],
	"./CryptoPriceChart.vue": [
		"679e",
		"chunk-50f31ec3",
		"chunk-99280230"
	],
	"./CryptoWatchList.vue": [
		"c772",
		"chunk-d1cab298"
	],
	"./CustomList.vue": [
		"dcd8",
		"chunk-162434b6"
	],
	"./CustomSearch.vue": [
		"8e89",
		"chunk-0ca0f1b0"
	],
	"./CveVulnerabilities.vue": [
		"c632",
		"chunk-0fbf65f2"
	],
	"./DomainMonitor.vue": [
		"3bae",
		"chunk-02723d07"
	],
	"./DroneCi.vue": [
		"ebe5",
		"chunk-453c77f4"
	],
	"./EmbedWidget.vue": [
		"ec79",
		"chunk-c02e690a"
	],
	"./EthGasPrices.vue": [
		"91f0",
		"chunk-50f31ec3",
		"chunk-f409524a"
	],
	"./ExchangeRates.vue": [
		"a65f",
		"chunk-532f6d8f"
	],
	"./Flights.vue": [
		"a75b",
		"chunk-682c81e9"
	],
	"./GitHubProfile.vue": [
		"e160",
		"chunk-0f886a7e"
	],
	"./GitHubTrending.vue": [
		"3134",
		"chunk-79418e87"
	],
	"./GlAlerts.vue": [
		"6193",
		"chunk-0cdd2e29"
	],
	"./GlCpuCores.vue": [
		"3237",
		"chunk-14b6750d"
	],
	"./GlCpuGauge.vue": [
		"9304",
		"chunk-85c144f4"
	],
	"./GlCpuHistory.vue": [
		"0949",
		"chunk-50f31ec3",
		"chunk-2f6d4cbb"
	],
	"./GlCpuSpeedometer.vue": [
		"29f0",
		"chunk-11a8d916"
	],
	"./GlCpuTemp.vue": [
		"6134",
		"chunk-1933b5c3"
	],
	"./GlDiskIo.vue": [
		"35a8",
		"chunk-c3affc54"
	],
	"./GlDiskSpace.vue": [
		"1f55",
		"chunk-c7c6f99e"
	],
	"./GlIpAddress.vue": [
		"82d1",
		"chunk-6b5de1e1"
	],
	"./GlLoadHistory.vue": [
		"ce80",
		"chunk-50f31ec3",
		"chunk-07dd6908"
	],
	"./GlMemGauge.vue": [
		"2af9",
		"chunk-142b1187"
	],
	"./GlMemHistory.vue": [
		"dccf",
		"chunk-50f31ec3",
		"chunk-5106115e"
	],
	"./GlMemSpeedometer.vue": [
		"8f1b",
		"chunk-6d98802d"
	],
	"./GlNetworkInterfaces.vue": [
		"4558",
		"chunk-286deec8"
	],
	"./GlNetworkTraffic.vue": [
		"bf13",
		"chunk-50f31ec3",
		"chunk-4352cb7e"
	],
	"./GlSystemLoad.vue": [
		"7ce6",
		"chunk-50f31ec3",
		"chunk-c0f28fc6"
	],
	"./GluetunStatus.vue": [
		"4841",
		"chunk-44cb61f1"
	],
	"./HackernewsTrending.vue": [
		"2213",
		"chunk-2b4a3926"
	],
	"./HealthChecks.vue": [
		"dac2",
		"chunk-022257e3"
	],
	"./IframeWidget.vue": [
		"2386",
		"chunk-7b5f88fd"
	],
	"./ImageWidget.vue": [
		"2356",
		"chunk-05cea6b3"
	],
	"./Jokes.vue": [
		"7b50",
		"chunk-cee89fa8"
	],
	"./Linkding.vue": [
		"7b54",
		"chunk-677c8830"
	],
	"./MinecraftStatus.vue": [
		"0723",
		"chunk-6cfb58d6"
	],
	"./MullvadStatus.vue": [
		"1e8e",
		"chunk-4f2c58c5"
	],
	"./Mvg.vue": [
		"c9a3",
		"chunk-b1e0bc9a"
	],
	"./MvgConnection.vue": [
		"ba75",
		"chunk-93c6be8c"
	],
	"./NdCpuHistory.vue": [
		"e641",
		"chunk-50f31ec3",
		"chunk-2ab49ff8"
	],
	"./NdLoadHistory.vue": [
		"47ad",
		"chunk-50f31ec3",
		"chunk-d42744f4"
	],
	"./NdRamHistory.vue": [
		"1afb",
		"chunk-50f31ec3",
		"chunk-0c51289a"
	],
	"./NewsHeadlines.vue": [
		"f406",
		"chunk-c7455828"
	],
	"./NextcloudNotifications.vue": [
		"f48c",
		"chunk-3ddd60cc"
	],
	"./NextcloudPhpOpcache.vue": [
		"8eac",
		"chunk-3338e30f"
	],
	"./NextcloudStats.vue": [
		"f9cc",
		"chunk-18245a10"
	],
	"./NextcloudSystem.vue": [
		"2f96",
		"chunk-50f31ec3",
		"chunk-253665e3"
	],
	"./NextcloudUser.vue": [
		"f298",
		"chunk-1604e3d4"
	],
	"./NextcloudUserStatus.vue": [
		"2937",
		"chunk-6735a5d0"
	],
	"./PiHoleStats.vue": [
		"3ce5",
		"chunk-50f31ec3",
		"chunk-4c36c634"
	],
	"./PiHoleStatsV6.vue": [
		"f489",
		"chunk-50f31ec3",
		"chunk-2daa5932"
	],
	"./PiHoleTopQueries.vue": [
		"7309",
		"chunk-5864ebd8"
	],
	"./PiHoleTopQueriesV6.vue": [
		"9029",
		"chunk-1e62e410"
	],
	"./PiHoleTraffic.vue": [
		"e61b",
		"chunk-50f31ec3",
		"chunk-2d225b78"
	],
	"./PiHoleTrafficV6.vue": [
		"2be7",
		"chunk-50f31ec3",
		"chunk-2d0bd7d8"
	],
	"./Proxmox.vue": [
		"8715",
		"chunk-7abb8001"
	],
	"./PublicHolidays.vue": [
		"79b9",
		"chunk-2e950f7e"
	],
	"./PublicIp.vue": [
		"4f0c",
		"chunk-abcb215a"
	],
	"./RescueTime.vue": [
		"1b90",
		"chunk-17937fcc"
	],
	"./RssFeed.vue": [
		"4f87",
		"chunk-789e8a61"
	],
	"./Sabnzbd.vue": [
		"2e26",
		"chunk-093443e6"
	],
	"./SportsScores.vue": [
		"7fa8",
		"chunk-1a47b6cf"
	],
	"./StatPing.vue": [
		"d71a",
		"chunk-4590fea8"
	],
	"./StockPriceChart.vue": [
		"b1f5",
		"chunk-50f31ec3",
		"chunk-2516f6d1"
	],
	"./SynologyDownload.vue": [
		"5a4b",
		"chunk-7cade872"
	],
	"./SystemInfo.vue": [
		"0021",
		"chunk-50f31ec3",
		"chunk-61d5ad94"
	],
	"./TacticalRMM.vue": [
		"93a5",
		"chunk-542a53f9"
	],
	"./TflStatus.vue": [
		"5d62",
		"chunk-b52460ac"
	],
	"./UptimeKuma.vue": [
		"709a",
		"chunk-5119af0e"
	],
	"./UptimeKumaStatusPage.vue": [
		"1e46",
		"chunk-741fb711"
	],
	"./WalletBalance.vue": [
		"6d7b",
		"chunk-09c28aed"
	],
	"./Weather.vue": [
		"048f",
		"chunk-367a1662"
	],
	"./WeatherForecast.vue": [
		"d76f",
		"chunk-2e400f87"
	],
	"./WidgetBase.vue": [
		"2955"
	],
	"./XkcdComic.vue": [
		"a2e3",
		"chunk-4a72a42d"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "50ed";
module.exports = webpackAsyncContext;